/** @jsxImportSource @emotion/react */
import { ThemeProvider } from "@emotion/react";
import i18n from "i18next";
import { useContext } from "react";
import { initReactI18next } from "react-i18next";
import "./App.css";
import { CategoryContext } from "./contexts/CategoryContext";
import { LanguageContext } from "./contexts/LanguageCtx";
import MainPage from "./pages/MainPage";
import StartPage from "./pages/StartPage";
import { theme } from "./theme/theme";
import lang_de from "./translations/de.json";
import lang_en from "./translations/en.json";
import Box from "./components/Box/Box";
import { showLanguageButtons } from "./config/config";

const resources = {
  en: { translation: lang_en },
  de: { translation: lang_de },
};

function App() {

  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext);
  const { category } = useContext(CategoryContext);

  i18n.use(initReactI18next).init({
    resources,
    lng: selectedLanguage === "en" ? "en" : "de",
    interpolation: {
      escapeValue: false,
    },
  });

  return (
    <ThemeProvider theme={theme}>
      {!showLanguageButtons && <Box
        style={{
          position: "fixed",
          marginLeft: 70,
          bottom: 10,
          zIndex: 99
        }}
      >
        <button css={{width: 80, height: 30, backgroundColor: theme.colors.primary, color: 'white'}} onClick={() => setSelectedLanguage("en")}> en </button>
        <button css={{width: 80, height: 30, color: theme.colors.primary}}  onClick={() => setSelectedLanguage("de")}> de </button>
      </Box>}

      {!category || category === "sustainabilityCommitments2030" ? (
        <StartPage />
      ) : (
        <MainPage />
      )}
    </ThemeProvider>
  );
}

export default App;
